import controller from './label-details.controller';

const template = require('./label-details.html');

export default {
    bindings: {
        label: '<',
        onSaved: '&',
        onEditCancelled: '&',
        onDeleted: '&',
        onNameChange: '&'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/labels/label-details/label-details.component.js